import Box from '@mui/material/Box'
import { resolveNotificationIconSrc } from '../lib/notification-icon'
import {
  notificationIconImgSx,
  notificationIconTileSx,
} from '../styles/notificationsPageStyles'

type Props = {
  title: string
}

/** Type icon tile — full `/notifications` page only (not bell dropdown). */
export function NotificationTypeIcon({ title }: Readonly<Props>) {
  const iconSrc = resolveNotificationIconSrc(title)

  return (
    <Box sx={notificationIconTileSx} aria-hidden>
      <Box component="img" src={iconSrc} alt="" sx={notificationIconImgSx} />
    </Box>
  )
}
